module.exports = __webpack_public_path__ + "static/media/webpack.93308132.png";